<template>
    <div v-if="showButton" class="survey-response-bubble">
        <v-scale-transition>
            <v-card
                v-if="fab"
                width="300"
                class="survey-response-bubble__card pa-4"
                elevation="8"
            >
                <v-btn
                    icon
                    small
                    color="black"
                    class="survey-response-bubble__close"
                    @click="closeBanner"
                >
                    <v-icon small>mdi-close</v-icon>
                </v-btn>
                <div class="d-flex align-start">
                    <v-avatar color="black" size="42" class="mr-3">
                        <v-icon color="white">mdi-message-question-outline</v-icon>
                    </v-avatar>
                    <div class="pr-5">
                        <h3 class="survey-response-bubble__title mb-2">{{ bannerTitle }}</h3>
                        <p class="survey-response-bubble__body mb-3">{{ bannerBody }}</p>
                        <v-btn color="black" dark small class="px-4" @click="openSurvey">
                            {{ bannerButtonText }}
                        </v-btn>
                    </div>
                </div>
            </v-card>
        </v-scale-transition>

        <v-tooltip right v-if="!fab">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class="survey-response-bubble__button"
                    color="black"
                    dark
                    fab
                    v-bind="attrs"
                    v-on="on"
                    @click="openBanner"
                >
                    <v-icon>mdi-message-question-outline</v-icon>
                </v-btn>
            </template>
            <span>{{ bannerTitle }}</span>
        </v-tooltip>
        <v-snackbar 
            v-model="successSurveyMessage" color="success" top
            timeout="2500" class="pt-8"
        >
            <h3 class="d-flex align-center justify-center">{{ $t('delivery.surveys.response.thanks') }}</h3>
        </v-snackbar>

        <v-dialog v-model="surveyDialog" width="auto" persistent>
            <survey-response
                with-cancel
                :surveyId="surveyId"
                @send="sendSurveyResponse"
                @cancel="cancelSurveyResponse"
            ></survey-response>
        </v-dialog>
    </div>
</template>

<script>
    import SurveyViewConfigProvider from '../../../delivery/providers/SurveyViewConfigProvider'
    import SurveyResponse from '../SurveyResponse'
    // import SurveyResponseProvider from '../../../delivery/providers/SurveyResponseProvider'

    export default {
        name: "SurveyResponseBubble",
        components: {SurveyResponse},
        data: () => ({
            fab: false,
            surveyDialog: false,
            surveyId: '',
            showButton: false,
            successSurveyMessage: false,
            bannerTitle: '',
            bannerBody: '',
            bannerButtonText: '',
            sessionStorageKey: 'survey-response-bubble-minimized'
        }),
        mounted(){
            this.loadSurvey()
        },
        methods: {
            closeBanner(){
                this.fab = false
                sessionStorage.setItem(this.sessionStorageKey, 'true')
            },
            openBanner(){
                this.fab = true
            },
            openSurvey(){
                this.surveyDialog = true
                this.fab = false
            },
            async loadSurvey(){
                try {
                    const {data: {fetchSurveyViewConfig}} = await SurveyViewConfigProvider.fetchSurveyViewConfig()
                    const homeView = fetchSurveyViewConfig.find(item => item.view === 'home')
                    if(!homeView || !homeView.enable || !homeView.survey) return
                    this.surveyId = homeView.survey.id
                    this.bannerTitle = homeView.bannerTitle || this.$t('delivery.surveys.viewConfig.placeholders.bannerTitle')
                    this.bannerBody = homeView.bannerBody || this.$t('delivery.surveys.viewConfig.placeholders.bannerBody')
                    this.bannerButtonText = homeView.bannerButtonText || this.$t('delivery.surveys.viewConfig.placeholders.bannerButtonText')
                    this.showButton = true
                    this.fab = sessionStorage.getItem(this.sessionStorageKey) !== 'true'
                } catch (error) {
                    console.error(error)
                }
            },
            sendSurveyResponse() {
                this.surveyDialog = false
                this.successSurveyMessage = true
            },
            cancelSurveyResponse(){
                this.surveyDialog = false
            }
        }
    }
</script>

<style scoped>
    .survey-response-bubble {
        position: fixed;
        left: 16px;
        bottom: 16px;
        z-index: 9999;
    }

    .survey-response-bubble__card {
        border-radius: 8px;
        border-left: 6px solid #f6a800;
    }

    .survey-response-bubble__close {
        position: absolute;
        top: 6px;
        right: 6px;
    }

    .survey-response-bubble__title {
        font-size: 1.05rem;
        line-height: 1.25rem;
        word-break: break-word;
    }

    .survey-response-bubble__body {
        color: rgba(0, 0, 0, 0.7);
        font-size: 0.9rem;
        line-height: 1.25rem;
        word-break: break-word;
    }

    .survey-response-bubble__button {
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);
    }

    .survey-response-bubble__button:after {
        border: 2px solid #f6a800;
        border-radius: inherit;
        bottom: -4px;
        content: "";
        left: -4px;
        pointer-events: none;
        position: absolute;
        right: -4px;
        top: -4px;
    }
</style>
